module.exports = __webpack_public_path__ + "img/booking_icon.d2d49d66.svg";